import { Link } from "react-router-dom";
import "./styles.css"
import { useId } from "react";

const NoAccess = ({ message = "Something went wrong! Please try again.", login = false, error = false }) => {
    const id = useId()
    return (
        <div id="noAccess" key={`noAccess_${id}`}>
            <div className="wrapper">
                {login ? (
                    <NoAccessLoginTemplate />
                ) : error ? (
                    <NoAccessErrorTemplate message={message} />
                ) : (
                    <NoAccess404Template />
                )}
            </div>
        </div>
    )
}

export default NoAccess;

const NoAccessLoginTemplate = () => {
    return (
        <div className="welcome font-book">
            Welcome
        </div>
    )
}

const NoAccess404Template = () => {
    return (
        <div style={{ textAlign: "center", display: "flex", flexDirection: "column", gap: ".5rem" }}>
            <h1>404</h1>
            <h2>Page Not Found</h2>
            <div className="error404 font-book">
                Sorry, the page you are looking for does not exist or has been moved.
            </div>
            <p>
                <Link to={"/"} className="font-book" style={{ textDecoration: "none", fontSize: "1.3rem" }}>MyOutfront.com</Link>
            </p>
        </div>
    )
}

const NoAccessErrorTemplate = ({ message }) => {
    return (
        <div className="error404">
            Error: {message}
        </div>
    )
}